<template>
  <div
    class=" right-panel p-0 m-0 pt-30"
    @click="panelClicked">
    <div class="d-flex flex-row justify-content-center align-items-center px-16">
      <button
        v-tooltip="'Undo'"
        type="button"
        class="btn btn-lightest-gray border border-1 me-12 btn-height-width position-relative btn-outline-0 undo-btn tooltip-button"
        @click="undoChanges">
        <icon name="undo"/>
      </button>
      <button
        v-tooltip="'Redo Last Action'"
        id="redo"
        type="button"
        class="btn btn-lightest-gray border border-1 me-12 btn-height-width undo-btn position-relative tooltip-button"
        @click="redoChanges">
        <icon name="redo"/>
      </button>
      <button
        v-tooltip="'Reset Changes'"
        :disabled="isResetDisabled"
        type="button"
        class="btn btn-lightest-gray border border-1 btn-height-width undo-btn position-relative"
        @click="resetUndoRedoArray">
        <icon name="rest"/>
      </button>
    </div>
    <layer-tag
      :content-list-receive="contentList"
      :product="product"
      :active-page="getActivePageIndex"
    />
  </div>
</template>
<script>


import Layer from '@/components/Layer/Layer';
import ColorPicker from '@/components/ColorPicker/ColorPicker';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:       'RightPanel',
  components: {
    'layer-tag': Layer,
    'color-tag': ColorPicker,
  },
  props: {
    product: {
      type: Object,
    },
    contentList: {
      type:    Array,
      default: [],
    },
    activePage: {
      type:    Number,
      default: -1,
    },
  },
  data() {
    return { isResetDisabled: true };
  },
  computed: {
    getActivePageIndex() {
      return this.activePage;
    },
  },
  mounted() {
    EventBus.$on('setValueForUndoRedoReset', this.onSetValueForUndoRedoReset);
  },
  destroyed() {
    EventBus.$off('setValueForUndoRedoReset', this.onSetValueForUndoRedoReset);
  },
  methods: {
    panelClicked() {
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CLOSE_PRODUCT_SIZE_DROPDOWN);
    },
    onSetValueForUndoRedoReset(value) {
      this.isResetDisabled = value;
    },
    undoChanges() {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, 'undo');
      // EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_DURATION_UPDATED, 'undo');
    },
    redoChanges() {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, 'redo');
      // EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_DURATION_UPDATED, 'redo');
    },
    resetUndoRedoArray() {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.RESET_PAGE_UNDO_REDO);
    },
    showTooltip(e) {
      const Id = e.currentTarget.id;
      EventBus.$emit('checkToolTip', Id);
    },
    hideTooltip() {
      EventBus.$emit('triggerHide');
    },
  },
};

</script>
<style lang="scss">
.right-panel {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
  width: 256px;
  max-height: calc(100vh - 68px);
  height: fit-content;
  overflow-y: auto;
  overflow-x: hidden;

  .tooltip-wrapper {
    top: 52px;
  }

  .undo-btn {
    &:hover {
      box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
      background: $white;
      border: 1px solid $white !important;
      transition: none !important;
    }
  }

  .btn-height-width {
    min-width: 68px;
    height: 44px;
  }
}
</style>
